module.exports = __webpack_public_path__ + "static/img/1470066081.07c3cfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/1470066081.jpg
// module id = ttbh
// module chunks = 1